/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fetcher } from "./sender";
import { CFG_BASE_URL } from '../constants/config'

export const apiFoodType = {
    getAll() {
        return fetcher.get(`${CFG_BASE_URL}/foodTypes`);
    }
};